import Home from '@webkit/pages/typescript/Home';
import AccomodationList from '@webkit/pages/AccomodationList.js';
import Analytics from '@webkit/pages/Analytics.js';
import EditAccomodation from '@webkit/pages/typescript/EditAccomodationPage';
import Login from '@webkit/pages/Login.js';
import NewAccomodation from '@webkit/pages/DashboardNodeAccomodation.js';
import Profile from '@webkit/pages/Profile.js';
import Settings from '@webkit/pages/Settings.js';
import Signup from '@webkit/pages/Signup.js';
import { t } from 'i18next';
import CardInfo from '@webkit/pages/typescript/CardInfoPage';
import CardTextPage from '@webkit/pages/typescript/CardTextPage';
import CardLinkPage from '@webkit/pages/typescript/CardLinkPage';
import CreateAccomodationPage from '@webkit/pages/typescript/CreateAccomodationPage';
import EditCardTextPage from '@webkit/pages/typescript/EditCardTextPage';
import EditCardInfoPage from '@webkit/pages/typescript/EditCardInfoPage';
import EditCardLinkPage from '@webkit/pages/typescript/EditCardLinkPage';
import PricesAndPlansPage from '@webkit/pages/typescript/PricesAndPlansPage';
import EditCardContactPage from '@webkit/pages/typescript/EditCardContactPage';
import EditCardLocationPage from '@webkit/pages/typescript/EditCardLocationPage';
import EditCardSuggestionPage from '@webkit/pages/typescript/EditCardSuggestionPage';
import CardSuggestionPage from '@webkit/pages/typescript/CardSuggestionPage';

const MainRoutes = [
  {
    path: '/',
    name: t('title.home'),
    title: t('title.app_name'),
    element: Home,
  },
  {
    path: '/login',
    name: t('title.login'),
    title: t('title.app_name'),
    element: Login,

  },
  {
    path: '/signup',
    name: t('title.signup'),
    title: t('title.app_name'),
    element: Signup,

  },
  {
    path: '/new-app',
    name: t('title.new_app'),
    title: t('title.app_name'),
    element: CreateAccomodationPage,
  },
  {
    path: '/new-app/:accomodationId',
    name: t('title.new_app'),
    title: t('title.app_name'),
    element: NewAccomodation,
  },
  {
    path: '/new-app/:accomodationId/create-cardinfo',
    name: t('title.create_cardinfo'),
    title: t('title.app_name'),
    element: CardInfo,
  },
  {
    path: '/new-app/:accomodationId/:cardId/create-cardinfo',
    name: t('title.create_cardinfo'),
    title: t('title.app_name'),
    element: CardInfo,
  },
  {
    path: '/new-app/:accomodationId/:cardId/edit-cardInfo',
    name: t('title.create_cardtext'),
    title: t('title.app_name'),
    element: EditCardInfoPage,
  },
  {
    path: '/new-app/:accomodationId/:cardId/create-cardtext',
    name: t('title.create_cardtext'),
    title: t('title.app_name'),
    element: CardTextPage,
  },
  {
    path: '/new-app/:accomodationId/:cardId/edit-cardtext',
    name: t('title.create_cardtext'),
    title: t('title.app_name'),
    element: EditCardTextPage,
  },
  {
    path: '/new-app/:accomodationId/:cardId/create-cardlink',
    name: t('title.create_cardlink'),
    title: t('title.app_name'),
    element: CardLinkPage,
  },
  {
    path: '/new-app/:parentId/:cardId/edit-cardlink',
    name: t('title.create_cardlink'),
    title: t('title.app_name'),
    element: EditCardLinkPage,
  },
  /* {
    path: '/new-app/:accomodationId/:cardId/create-cardSuggestion',
    name: t('title.create_cardSuggestion'),
    title: t('title.app_name'),
    element: CardSuggestionPage,
  },
  {
    path: '/new-app/:parentId/:cardId/edit_cardSuggestion',
    name: t('title.edit_cardSuggestion'),
    title: t('title.app_name'),
    element: EditCardSuggestionPage,
  }, */
  {
    path: '/new-app/:parentId/edit-cardContact',
    name: t('title.edit_cardContact'),
    title: t('title.app_name'),
    element: EditCardContactPage,
  },
  {
    path: '/new-app/:parentId/edit-cardLocation',
    name: t('title.edit_cardLocation'),
    title: t('title.app_name'),
    element: EditCardLocationPage,
  },
  {
    path: '/:accomodationId/edit-app',
    name: t('title.home'),
    title: t('title.app_name'),
    element: EditAccomodation,

  },
  {
    path: '/apps',
    name: t('title.home'),
    title: t('title.app_name'),
    element: AccomodationList,

  },
  {
    path: '/analytics',
    name: t('title.home'),
    title: t('title.app_name'),
    element: Analytics,

  },
  {
    path: '/prices-plans',
    name: t('title.prices_plans'),
    title: t('title.prices_plans'),
    element: PricesAndPlansPage,

  },
  {
    path: '/settings',
    name: t('title.home'),
    title: t('title.app_name'),
    element: Settings,

  },
  {
    path: '/profile',
    name: t('title.home'),
    title: t('title.app_name'),
    element: Profile,

  }
];

export default MainRoutes;